import { useState, useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export type BoltwayEnv = 'development' | 'staging' | 'production';

const ENV_META: Record<BoltwayEnv, { label: string; color: string }> = {
  development: { label: 'Development', color: 'bg-info/10 text-info border-info/20' },
  staging: { label: 'Staging', color: 'bg-warning/10 text-warning border-warning/20' },
  production: { label: 'Production', color: 'bg-success/10 text-success border-success/20' },
};

export function useEnvironment() {
  const [env, setEnv] = useState<BoltwayEnv>(() => {
    return (localStorage.getItem('bw-env') as BoltwayEnv) || 'development';
  });

  useEffect(() => {
    localStorage.setItem('bw-env', env);
  }, [env]);

  return { env, setEnv };
}

export function EnvironmentSwitcher() {
  const { env, setEnv } = useEnvironment();
  const meta = ENV_META[env];

  return (
    <Select value={env} onValueChange={(v) => setEnv(v as BoltwayEnv)}>
      <SelectTrigger className="h-7 w-[130px] text-[11px] border-0 bg-transparent gap-1.5 px-2">
        <div className={`h-2 w-2 rounded-full ${env === 'production' ? 'bg-success' : env === 'staging' ? 'bg-warning' : 'bg-info'}`} />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {Object.entries(ENV_META).map(([key, { label, color }]) => (
          <SelectItem key={key} value={key} className="text-[11px]">
            <div className="flex items-center gap-2">
              <div className={`h-2 w-2 rounded-full ${key === 'production' ? 'bg-success' : key === 'staging' ? 'bg-warning' : 'bg-info'}`} />
              {label}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
